import TilesPrayerContainer from "@/components/tiles-prayer-container/TilesPrayerContainer";
import tidesIcon from "@/img/tiles-icon.svg";

import { WEATHER_STORE } from "@/store/store";
import { WeatherSelect } from "@/store/type";
import { useSelect } from "@wordpress/data";
import { formatCurrentDayWithMonth } from "@/helpers/format-date";
import { formatDailyTimedEvents } from "@/helpers/format-prayer-tide";
import { useTranslation } from "react-i18next";
import { getCurrentLanguage } from "@/helpers/get-current-langage";

import "./style.scss";

export const App = () => {
	const lang = getCurrentLanguage();
	const { t } = useTranslation();

	const { name_en, date, error, tidesData } = useSelect(
		(select: (store: typeof WEATHER_STORE) => WeatherSelect) => {
			const store = select(WEATHER_STORE);

			return {
				...store.getMarineDate(),
				...store.getLocationMarine(),
				...store.getTideState(),
			};
		},
	);

	if (error) {
		return <p>An error occured</p>;
	}

	return (
		<section className="tiles-app">
			<TilesPrayerContainer
				showCurrentType={true}
				title={t("tideTimes")}
				icon={<img src={tidesIcon} alt="tides icon" />}
				info={`${formatCurrentDayWithMonth(date)} - ${name_en}`}
				data={formatDailyTimedEvents(tidesData, lang, "tide", date, false)}
			/>
		</section>
	);
};

export default App;
